const config = {
  canvas: {
    styles: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css'
    ],
    scripts: []
  }
}

export default config
